import React, { Component } from "react"
import PropTypes from "prop-types"

import "./Icon.scss"
import { AEM_ASSETS } from "components/Stacker/AEMConstants"

function updateIcons(ref, blobPath) {
  if (ref.iconRef.current) {
    var curentHref = ref.iconRef.current.href.baseVal
    var href = curentHref.replace("__BLOBPATH__", blobPath)
    ref.iconRef.current.href.baseVal = href
  }
}

class Icon extends Component {
  constructor(props) {
    super(props)
    this.iconRef = React.createRef()
    this.state = { blob: null }
  }

  componentDidMount() {
    fetch(`${AEM_ASSETS}/icons/symbol-defs.svg`)
      .then((r) => r.blob())
      .then((b) => {
        this.setState({ blob: b })
        updateIcons(this, URL.createObjectURL(b))
      })
  }

  componentDidUpdate(prevProps) {
    if (this.state.blob) {
      updateIcons(this, URL.createObjectURL(this.state.blob))
    }
  }

  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`Icon svg-icon ${this.props.additionalClassNames}`}
      >
        <use ref={this.iconRef} href={`__BLOBPATH__#${this.props.iconName}`} />
      </svg>
    )
  }
}

Icon.propTypes = {
  iconName: PropTypes.string.isRequired,
  additionalClassNames: PropTypes.string,
}

export default Icon
